import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default (props) => {
  const { isOpen } = props;
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isOpen || false}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};